import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-staff',
  templateUrl: './staff.component.html',
  styleUrls: ['./staff.component.scss']
})
export class StaffComponent implements OnInit {
  staff: { Name: string, Qualification: string, Designation: string }[] =
    [
      { Name: "Mrs. Deepinder Walia", Qualification: "M.A,M.Ed,Phd.", Designation: "Principal" },
      { Name: "Renu Bala", Qualification: "B.A., B. Ed., M.Ed. & NTT", Designation: "TGT" },
      { Name: "Babita Rani", Qualification: "B.A.& B. Ed.", Designation: "TGT" },
      { Name: "Renu Bala", Qualification: "M.A.& B. Ed.", Designation: "TGT" },
      { Name: "Alka Jain", Qualification: "B.A., B. Ed. & M.A. (History)", Designation: "PGT" },
      { Name: "Narendra Kaur", Qualification: "B.Sc., B. Ed.", Designation: "TGT" },
      { Name: "Vandana", Qualification: "M.A. & B. Ed.", Designation: "PGT" },
      { Name: "Anita Sharma", Qualification: "B.A. & B. Ed.", Designation: "TGT" },
      { Name: "Sushma Tanwar", Qualification: "B.A. & B. Ed.", Designation: "TGT" },
      { Name: "Mrs. Manpreet Kaur", Qualification: "M.A.(English), NTT,", Designation: "PGT" },
      { Name: "Neelam Bangar", Qualification: "M. Lib.", Designation: "Lib." },
      { Name: "Meenakshi Garg", Qualification: "M. Com.", Designation: "NTT" },
      { Name: "Kanta Rani", Qualification: "B. A. & NTT.", Designation: "NTT" },
      { Name: "Manpreet Kaur", Qualification: "M.Sc Computer Science", Designation: "TGT" },
      { Name: "Bharti Devi", Qualification: "M. A. & B. Ed.", Designation: "NTT" },
      { Name: "Pooja Chitkara", Qualification: "B.A., NTT", Designation: "NTT" },
      { Name: "Sangeeta Aggarwal", Qualification: "B. Sc., B. Ed. & M.A. (English)", Designation: "PGT" },
      { Name: "Reemu Goyal", Qualification: "M. A., B. Ed. (Math)", Designation: "PGT" },
      { Name: "Gurpreet Singh", Qualification: "M.Sc.(Physics), B.Ed", Designation: "PGT" },
      { Name: "Jyotsna Behal", Qualification: "M.A., B.Ed.,", Designation: "PGT" },
      { Name: "Narinder Singh", Qualification: "B.P.Ed.", Designation: "PTI" },
      { Name: "Mamta Arora", Qualification: "M.A Hindi,Prabhakar", Designation: "TGT" },
      { Name: "Poonam Budhiraja", Qualification: "M.com, B.Ed.", Designation: "TGT" },
      { Name: "Jyoti", Qualification: "B.A., M.A. (Hindi) & NTT", Designation: "NTT" },
      { Name: "Suman", Qualification: "M.A., B.Ed", Designation: "NTT" },
      { Name: "Satvinder Singh", Qualification: "M.Com", Designation: "Accountant" },
      { Name: "Suman Chahal", Qualification: "M.A. (Eng) & B.Ed", Designation: "TGT" },
      { Name: "Nisha Arora", Qualification: "M.Com, B.Ed", Designation: "PGT" },
      { Name: "Shelly", Qualification: "M.A. Economics, B.Ed", Designation: "PRT" },
      { Name: "Amanpreet Kaur Gaba", Qualification: "B.A., N.T.T.", Designation: "NTT" },
      { Name: "Gunjan Sharma", Qualification: "M.A. Math, B.Ed., M.Ed.", Designation: "PGT" },
      { Name: "Rajeev Kumar", Qualification: "B.A. Diploma in Arts & Craft", Designation: "PRT" },
      { Name: "Meenakshi Kohli", Qualification: "M.A., M.ED", Designation: "TGT" },
      { Name: "Ravinder Pal", Qualification: "M.PHIl, B.Ed, M.A. (English, Liguistics)", Designation: "Vice Principal" },
      { Name: "Sonia Chadha", Qualification: "M.Com, M.Phil., B.Ed", Designation: "TGT" },
      { Name: "Roopa Jha", Qualification: "M.com, M.Phill, B.Ed", Designation: "PGT" },
      { Name: "Prishita", Qualification: "MBA. M.Com, B.Ed", Designation: "PGT" },
      { Name: "Neelam Rani", Qualification: "B.Ed., B.A.,NTT", Designation: "TGT" },
      { Name: "Ankush Goyal", Qualification: "MA Eco. B.Ed, M.Ed", Designation: "PGT (Eco)" },
      { Name: "Usha Rani", Qualification: "MA. B.Ed", Designation: "NTT" },
      { Name: "Sarojni Sharma", Qualification: "B.A., M.A. (English)", Designation: "PRT" },
      { Name: "Monika", Qualification: "B.SC.,", Designation: "NTT" },
      { Name: "Manvinder Singh", Qualification: "B.P.Ed., M.A. (Phy. Edu)", Designation: "PGT (Phy. Edu.)" },
      { Name: "Nitu Rani", Qualification: "B.A., B.Ed. With computer", Designation: "NTT" },
      { Name: "Deepa Rani", Qualification: "M.A. JBT, PRABHAKAR", Designation: "NTT" },
      { Name: "Promila Singhal", Qualification: "B. Tech, M. Tech", Designation: "TGT" },
      { Name: "Charlie Bedi", Qualification: "B.Ed, M.Sc.", Designation: "PGT" },
      { Name: "Sharun", Qualification: "BTEC, Civil Engineer, Auto Cad, BCA,", Designation: "TGT" },
      { Name: "Swaran Singh", Qualification: "M.Sc., I.T.", Designation: "PGT" },
      { Name: "Sheetal", Qualification: "", Designation: "PRT" },
      { Name: "Heena Munjal", Qualification: "B.Sc, B.Ed, MBA", Designation: "Coordinator" },
      { Name: "Saral", Qualification: "", Designation: "PRT" },
      { Name: "Sita Ram", Qualification: "B.Com", Designation: "Clerk" },
      { Name: "RAMANDEEP KAUR", Qualification: "12TH", Designation: "Lab Attendant" },
      { Name: "Parveen", Qualification: "B.A., M.A. (Punjabi)", Designation: "PRT" },
      { Name: "Gurpreet Kaur", Qualification: "B.A.", Designation: "NTT" },
      { Name: "Amit Dhariwal", Qualification: "Diploma in sports", Designation: "PTI" },
      { Name: "Sangeeta Baweja", Qualification: "M.A., B.ED", Designation: "Coordinator" },
      { Name: "Khushboo", Qualification: "B. Sc, B.Ed, HTET", Designation: "Computer Teacher" },
      { Name: "Nisha Rani", Qualification: "B.A. (NTT)", Designation: "NTT" },
      { Name: "Maninder Singh", Qualification: "B.Com", Designation: "Supervisor" },
      { Name: "Nancy", Qualification: "BA", Designation: "PGT" },
      { Name: "Shipra", Qualification: "B.Com., B.Ed. M.Com", Designation: "NTT" },
      { Name: "Gurjeet Kour", Qualification: "B.Com,", Designation: "NTT" },
      { Name: "Anjali", Qualification: "M.A., B.Ed.,", Designation: "PGT (Commercial Art)" },
      { Name: "Santosh", Qualification: "M.Com", Designation: "NTT" }
    ]
  constructor() { }

  ngOnInit(): void {
  }

}
